import { Container } from '../../../odie';

import { RainbowBubbleBlockProps } from '../../defs/block';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';

const manifest = {
  image: 'rainbowBubble/block.rainbowBubble.png',
};

export class RainbowBubbleBlockView extends Container {
  constructor(props: RainbowBubbleBlockProps) {
    super();

    const bubble = new FitWidthBlockSprite(manifest.image, props);
    bubble.scaleX *= 1.25;
    bubble.scaleY *= 1.25;
    bubble.y = 5;
    this.addChild(bubble);

    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return [manifest.image];
  }
}
